import type React from "react";

import { useNProgress } from "@tanem/react-nprogress";

export const Progress: React.FC<{
  isAnimating: boolean;
  className?: string;
  barClassName?: string;
}> = ({ isAnimating, className, barClassName }) => {
  const { animationDuration, isFinished, progress } = useNProgress({
    minimum: 0.4,
    animationDuration: 300,
    isAnimating,
  });

  return (
    <Container
      animationDuration={animationDuration}
      isFinished={isFinished}
      className={className}
    >
      <Bar
        animationDuration={animationDuration}
        progress={progress}
        className={barClassName}
      />
      {/*
      This example doesn't use a spinner component so the UI stays
      tidy. You're free to render whatever is appropriate for your
      use-case.
      */}
    </Container>
  );
};

const Container = ({
  animationDuration,
  children,
  isFinished,
  className,
}: {
  animationDuration: number;
  children: React.JSX.Element;
  isFinished: boolean;
  className?: string;
}) => (
  <div
    className={className}
    style={{
      opacity: isFinished ? 0 : 1,
      pointerEvents: "none",
      transition: `opacity ${animationDuration}ms linear`,
    }}
  >
    {children}
  </div>
);

const Bar = ({
  animationDuration,
  progress,
  className,
}: {
  animationDuration: number;
  progress: number;
  className?: string;
}) => (
  <div
    className={className}
    style={{
      background: "#29d",
      height: 2,
      left: 0,
      marginLeft: `${(-1 + progress) * 100}%`,
      position: "absolute",
      top: 0,
      transition: `margin-left ${animationDuration}ms linear`,
      width: "100%",
      zIndex: 1031,
    }}
  >
    <div
      style={{
        boxShadow: "0 0 10px #29d, 0 0 5px #29d",
        display: "block",
        height: "100%",
        opacity: 1,
        position: "absolute",
        right: 0,
        transform: "rotate(3deg) translate(0px, -4px)",
        width: 100,
      }}
    />
  </div>
);
